/**
 * 帮助文档链接
 *
 * 各处「操作说明 / 操作指引」统一指向自建文档站，集中在这里维护，
 * 换域名或调整文档结构时只改一处。
 */

/** 文档站首页，顶部「操作说明」入口用 */
export const DOC_HOME_URL = 'http://doc.youju360.com/';

/** 文档站内具体文章前缀 */
const DOC_BASE = 'http://doc.youju360.com/#/docs/plat_mtgkxvq75krr';

/** 抖音渠道授权指引 */
export const DOC_DOUYIN_AUTH = `${DOC_BASE}/doc_mtgkyak25bbl`;

/** 小红书渠道授权指引 */
export const DOC_XIAOHONGSHU_AUTH = `${DOC_BASE}/doc_mtgkyak2n3k2`;

/** 抖音飞鸽渠道授权指引 */
export const DOC_DY_FEIGE_AUTH = `${DOC_BASE}/doc_mtgkyak2e76h`;

/** 企业微信渠道授权指引 */
export const DOC_QYWX_AUTH = `${DOC_BASE}/doc_mtqo3gju1p5e`;

/** 腾讯咨询页渠道授权指引 */
export const DOC_TENCENT_AUTH = `${DOC_BASE}/doc_mtqomev6mj7c`;

/** 客资上报配置（巨量引擎授权）指引 */
export const DOC_CUSTOMER_REPORT = `${DOC_BASE}/doc_mtqtkzdfrmw5`;
